module.exports = __webpack_public_path__ + "images/emoji/black_joker.0029175ae47241ea66a5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_joker.png
// module id = EW0v
// module chunks = 13